import { Job } from '../../../vas/business-objects/job/job.model';
import { IJobFilters } from '../../../vas/business-objects/job/job.reducer';
import { JobListPageItemModel } from './job-list-page-item.model';
import * as actions from './job-list-page.actions';
import { JobListPageMode } from './job-list-page.types';

export interface State {
    mode: JobListPageMode;
    searchAllJobs: {
        loading: boolean;
        searchResults: Array<Job>;
        searchTerm: string;
        total: number;
    };
}

export const initialState: State = {
    mode: 'my-list',
    searchAllJobs: {
        loading: false,
        searchResults: [],
        searchTerm: undefined,
        total: 0
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {

    switch (action.type) {
        case actions.INITIALISE: {
            return {...initialState};
        }
        case actions.CACHE_TO_PAGE_SUCCESS: {
            return {
                ...state,
                ids: action.payload.jobs
                    .map(job => job.id),
                entities: action.payload.jobs
                    .reduce((p, c) => {
                        p[c.id] = c;
                        return p;
                    }, {})
            };
        }
        case actions.SET_MODE: {
            return {
                ...state,
                mode: action.payload.mode
            };
        }
        case actions.SET_SEARCH_TERM: {
            return {
                ...state,
                mode: 'search',
                searchAllJobs: {
                    ...state.searchAllJobs,
                    loading: true,
                    searchTerm: action.payload.searchTerm
                }
            };
        }
        case actions.SET_SEARCH_TERM_SUCCESS: {
            return  {
                ...state,
                searchAllJobs: {
                    ...state.searchAllJobs,
                    loading: false,
                    searchResults: action.payload.response.items,
                    total: action.payload.response.total
                }
            };
        }
        case actions.SET_SEARCH_TERM_FAIL: {
            return  {
                ...state,
                searchAllJobs: {
                    ...state.searchAllJobs,
                    loading: false
                }
            };
        }
        default: {
            return state;
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/pages/job-list-page/job-list-page.reducer.ts